var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    {
      staticClass: "py-3 border-bottom frame-extra",
      on: {
        click: function ($event) {
          $event.preventDefault()
          _vm.extraSelected = !_vm.extraSelected
        },
      },
    },
    [
      _c(
        "b-col",
        { attrs: { cols: "9" } },
        [
          _c(
            "b-form-checkbox",
            {
              class: { "text-muted": !_vm.validation.isValid },
              model: {
                value: _vm.extraSelected,
                callback: function ($$v) {
                  _vm.extraSelected = $$v
                },
                expression: "extraSelected",
              },
            },
            [
              _vm._v(_vm._s(_vm.name)),
              _c(
                "span",
                {
                  staticClass: "material-icons ml-2 product-info",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.openModal.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("info")]
              ),
            ]
          ),
          _vm.warning
            ? _c("p", { staticClass: "text-warning mb-0" }, [
                _c("small", [_vm._v(_vm._s(_vm.warning))]),
              ])
            : _vm._e(),
          !_vm.validation.isValid
            ? _vm._l(_vm.validation.problems, function (error, idx) {
                return _c(
                  "p",
                  {
                    key: `${_vm.modalId}-error-idx`,
                    staticClass: "text-danger mb-0",
                    class: { "mt-2": _vm.warning },
                  },
                  [_c("small", [_vm._v(_vm._s(error))])]
                )
              })
            : _vm._e(),
        ],
        2
      ),
      _c("b-col", { staticClass: "text-right", attrs: { cols: "3" } }, [
        _vm._v("£" + _vm._s(_vm.price)),
      ]),
      _c(
        "b-modal",
        { attrs: { id: _vm.modalId, title: _vm.name, "ok-only": "" } },
        [_vm._t("product-info")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }